/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import { StyledDivider } from "./action-menu";
import styled from "styled-components";
import { Link } from "react-router-dom";

const DividerMargin = styled(StyledDivider)`
  margin-left: 15px;
  padding: 0.3px;
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  height: 40px;
  color: black;
  &:hover {
    transform: scale(1.05);
    /*       opacity: 0.7;
      background: linear-gradient(132deg, #FC415A, #591BC5, #212335);
      color:white; */
  }
  & p {
    font-size: 13px;
    font-weight: 600;
  }
`;

export const MenuBlock = ({ block }: any) => {
  const { title, items } = block;
  return (
    <>
      <DividerMargin></DividerMargin>

      <ul>
        <p className="menu__block-item-title">{title}</p>
        {items.map((e: any, i: number) => (
          <StyledLink to={e.link} key={i}>
            <div>
              <img src={e.icon} alt="logo"></img>
            </div>
            <div style={{ marginLeft: "10px" }}>
              <p> {e.name}</p>
            </div>
          </StyledLink>
        ))}
      </ul>
    </>
  );
};
